import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { API_URL } from "services/config";
import { getColor } from "utils/colors";

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        tipoDeResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.tipoDeResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        descripcion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.descripcion}
            </SoftTypography>
          </SoftBox>
        ),
        dispositivoDeMedicion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.dispositivoDeMedicion ? "Sí" : "No"}
            </SoftTypography>
          </SoftBox>
        ),
        dispositivoDeDepuracion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.dispositivoDeDepuracion ? "Sí" : "No"}
            </SoftTypography>
          </SoftBox>
        ),
        tipoDeDispositivoDepuracion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.tipoDeDispositivoDepuracion || "N/A"}
            </SoftTypography>
          </SoftBox>
        ),
        tipoDeDispositivoMedicion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.tipoDeDispositivoMedicion || "N/A"}
            </SoftTypography>
          </SoftBox>
        ),
        frecuenciaDeEmisiones: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.frecuenciaDeEmisiones}
            </SoftTypography>
          </SoftBox>
        ),
        observaciones: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.observaciones || "Sin observaciones"}
            </SoftTypography>
          </SoftBox>
        ),
        archivoMedicion: (
          <SoftBox>
            {item?.dispositivoDeMedicion && item?.fileMedicion ? (
              <Tooltip title="Ver archivo de medición" placement="top">
                <a
                  href={
                    item.fileMedicion instanceof File
                      ? URL.createObjectURL(item.fileMedicion)
                      : `${API_URL}/${item.fileMedicion.file}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Icon
                    sx={{ color: getColor("gobPrimary"), cursor: "pointer", mx: 0.5 }}
                    fontSize="small"
                  >
                    attach_file
                  </Icon>
                </a>
              </Tooltip>
            ) : (
              "N/A"
            )}
          </SoftBox>
        ),
        archivoDepuracion: (
          <SoftBox>
            {item?.dispositivoDeDepuracion && item?.fileDepuracion ? (
              <Tooltip title="Ver archivo de medición" placement="top">
                <a
                  href={
                    item.fileDepuracion instanceof File
                      ? URL.createObjectURL(item.fileDepuracion)
                      : `${API_URL}/${item.fileDepuracion.file}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Icon
                    sx={{ color: getColor("gobPrimary"), cursor: "pointer", mx: 0.5 }}
                    fontSize="small"
                  >
                    attach_file
                  </Icon>
                </a>
              </Tooltip>
            ) : (
              "N/A"
            )}
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getColor("gobSecondary"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "tipoDeResiduo", desc: "Tipo de Residuo", align: "center", noOrder: true },
  { name: "descripcion", desc: "Descripción", align: "left", noOrder: true },
  { name: "dispositivoDeMedicion", desc: "Dispositivo de Medición", align: "left", noOrder: true },
  {
    name: "dispositivoDeDepuracion",
    desc: "Dispositivo de Depuración",
    align: "left",
    noOrder: true,
  },
  {
    name: "tipoDeDispositivoDepuracion",
    desc: "Tipo de Dispositivo de Depuración",
    align: "left",
    noOrder: true,
  },
  {
    name: "tipoDeDispositivoMedicion",
    desc: "Tipo de Dispositivo de Medición",
    align: "left",
    noOrder: true,
  },
  { name: "frecuenciaDeEmisiones", desc: "Frecuencia de Emisiones", align: "left", noOrder: true },
  { name: "observaciones", desc: "Observaciones", align: "left", noOrder: true },
  { name: "archivoMedicion", desc: "Archivo Medición", align: "center", noOrder: true },
  { name: "archivoDepuracion", desc: "Archivo Depuración", align: "center", noOrder: true },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
